import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_order_project_contact_by_typeIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId: number, typeId: number }): 
  Promise<{ result: { Id?: number, Project?: { Id?: number, Name?: string, ProjectsContactsLookup?: { ContactId?: number, Contact?: { Id?: number, FirstName?: string, LastName?: string, TypeId?: number, Address?: { City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[] } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil($inParams.typeId)) {
      $missingRequiredInParams.push('\'typeId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId: number, typeId: number    }) {
        if(isNil($inParams.orderId)) {
          return true; 
        }
        if(isNil($inParams.typeId)) {
          return true; 
        }
      return false;
    }
}
